import { useQuery } from 'react-query';
import { fetchHome } from "./services/HomeService";
import { CACHE_TTL_MS } from './ttl.cache';

export const useHome = (options = {}) => {
  const { shouldFetchHome = false } = options;

  const homeData = useQuery({
    queryKey: ["home"],
    queryFn: async () => {
      const data = await fetchHome();
      return data;
    },
    enabled: shouldFetchHome,
    staleTime: CACHE_TTL_MS.TTL_15_MINUTES,
    cacheTime: CACHE_TTL_MS.TTL_1_HOUR,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (error?.response?.status === 401) return false;
      return failureCount < 2;
    },
  });

  return {
    home: {
      data: homeData.data,
      isLoading: homeData.isLoading,
      error: homeData.error,
    },
  };
};
